import React, { useContext } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

import RenderPage from "./paginas/renderPage";
import { CondicaoContext } from "./contexto";
import Rotas from "./paginas/main";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function App() {
  const { condicao, loading } = useContext(CondicaoContext);

  // Aguarda a verificação da sessão antes de montar as rotas.
  if (loading) {
    return (
      <Box
        role="status"
        aria-live="polite"
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          backgroundColor: "#f5f5f5",
        }}
      >
        <CircularProgress aria-label="Verificando sessão" />

        <Typography sx={{ color: "text.secondary" }}>
          Verificando sessão...
        </Typography>
      </Box>
    );
  }

  // condicao = true: usuário não autenticado.
  if (condicao) {
    return <Rotas />;
  }

  // condicao = false: usuário autenticado.
  return (
    <RenderPage>
      <Rotas />
    </RenderPage>
  );
}
